export default "__VITE_ASSET__566d1550__"